import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  cartDetails,
  deleteCampaignFromCart,
  saveCampaignToCart,
  updateCheckedUnCheckedCart,
} from "../../../thunks/buyer-thunks/BuyerThunks";
const initialState = {
  campaignStatus: null,
  campaignCartDetails: [],
  isCartLoading: null,
  isSaveCartLoading: null,
};
export const campaignCartSlice = createSlice({
  name: "campaignscart",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(saveCampaignToCart.pending, (state) => {
        state.error = null;
        state.isSaveCartLoading = true;
      })
      .addCase(saveCampaignToCart.fulfilled, (state, action) => {
        state.isSaveCartLoading = false;
        state.campaignStatus = action.payload;
        message.success(action.payload.message);
      })
      .addCase(saveCampaignToCart.rejected, (state, action) => {
        state.error = action.payload;
        state.isSaveCartLoading = false;
        message.error("Something went wrong!");
      });

    //get cart details
    builder
      .addCase(cartDetails.pending, (state) => {
        state.error = null;
        state.isCartLoading = true;
      })
      .addCase(cartDetails.fulfilled, (state, action) => {
        state.isCartLoading = false;
        state.campaignCartDetails = action.payload;
      })
      .addCase(cartDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.isCartLoading = false;
        message.error("Something went wrong!");
      });

    //update checked and unchecked status for campaigns in cart
    builder
      .addCase(updateCheckedUnCheckedCart.pending, (state) => {
        state.error = null;
        state.isLoading = true;
        state.checkedStatus = null;
      })
      .addCase(updateCheckedUnCheckedCart.fulfilled, (state, action) => {
        state.isLoading = false;
        state.checkedStatus = action.payload;
      })
      .addCase(updateCheckedUnCheckedCart.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
        state.checkedStatus = null;
        message.error("Something went wrong!");
      });

    // deleting the campaign from the cart
    builder
      .addCase(deleteCampaignFromCart.pending, (state) => {
        state.error = null;
        state.isLoading = true;
        state.deleteStatus = null;
      })
      .addCase(deleteCampaignFromCart.fulfilled, (state, action) => {
        state.isLoading = false;
        state.deleteStatus = action.payload;
      })
      .addCase(deleteCampaignFromCart.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
        state.deleteStatus = null;
        message.error("Something went wrong!");
      });
  },
});

export default campaignCartSlice.reducer;
